export interface LogInterface {
    _id: string | number,
    user_id?: number,
    status: 'success' | 'error' | string,
    message: string,
    ref_id: string,
    ref_id1?: string | null,
    type: string,
    data: string | object | Array<any> | null,
    data1?: string | object | Array<any> | null,
    updated_at: string,
    created_at: string,
}

export const structLog: LogInterface = {
    _id: 0,
    created_at: "",
    data: null,
    data1: null,
    message: "",
    ref_id: "",
    status: "",
    type: "",
    updated_at: "",
}
